(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    define(['underscore', 'moment'], factory);
  } else if (typeof exports === 'object') {
    module.exports = factory(require('underscore'), require('moment'));
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function (_, moment) {
  'use strict';

  /**
   * Utility methods for dealing with formatting & parsing dates.
   *
   * @class dateUtils
   * @static
   */
  return {
    /**
     * @method getExpirationYear
     * @param expirationYearMonth the expiration date, in the form of YYYY-MM
     * @returns {String} the year of the expiration date.
     */
    getExpirationYear: function(expirationYearMonth) {
      var expirationYearMonthParts = this._getExpirationYearMonthParts(expirationYearMonth);
      return expirationYearMonthParts && expirationYearMonthParts[0];
    },

    /**
     * @method getExpirationMonth
     * @param expirationYearMonth the expiration date, in the form of YYYY-MM
     * @returns {String} the month of the expiration date.
     */
    getExpirationMonth: function(expirationYearMonth) {
      var expirationYearMonthParts = this._getExpirationYearMonthParts(expirationYearMonth);
      return expirationYearMonthParts && expirationYearMonthParts[1];
    },

    /**
     * @method convertYearMonthArrayToNumericArray
     * @param expirationYearMonth {(Number|String)[]} A year/month array that contains any combination of numbers and strings.
     * @return {Number[]} A normalized year/month array that only contains numbers.
     */
    convertYearMonthArrayToNumericArray: function (expirationYearMonth) {
      var expirationYear = expirationYearMonth[0];
      var expirationMonth = expirationYearMonth[1];
      var expirationYearNumber = expirationYear;
      var expirationMonthNumber = expirationMonth;
      if (_.isString(expirationYear)) {
        expirationYearNumber = expirationYear && parseInt(expirationYear, 10);
      }
      if (_.isString(expirationMonth)) {
        expirationMonthNumber = expirationMonth && parseInt(expirationMonth, 10);
      }
      return [expirationYearNumber, expirationMonthNumber];
    },

    /**
     * @method _getExpirationYearMonthParts
     * @param expirationYearMonth the expiration date, in the form of YYYY-MM, an array, or a numeric unix timestamp.
     * @returns {Array} the year (index 0) and month (index 1) of the expiration date.
     * @private
     */
    _getExpirationYearMonthParts: function(expirationYearMonth) {
      if (!expirationYearMonth) {
        return [];
      }

      if (_.isArray(expirationYearMonth)) {
        return this.convertYearMonthArrayToNumericArray(expirationYearMonth);
      }

      if (_.isNumber(expirationYearMonth)) {
        var expirationYearMonthMoment = moment(expirationYearMonth);
        var zeroBasedMonth = expirationYearMonthMoment.month();
        var oneBasedMonth = zeroBasedMonth + 1;
        return [expirationYearMonthMoment.year(), oneBasedMonth];
      }

      expirationYearMonth = expirationYearMonth.toString();
      if (expirationYearMonth.indexOf('-') <= -1) {
        return [];
      }

      // make sure we are returning numbers
      var expirationYearMonthStringArray = expirationYearMonth.split('-');
      return this.convertYearMonthArrayToNumericArray(expirationYearMonthStringArray);
    }
  };
}));
